var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWidget(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M149.6,502.9c-34.2,0-68.3,0-102.5,0c-23.7,0-38-14.3-38-38.2c0-68.7,0-137.4,0-206c0-23.4,14.3-38,37.6-38 c68.8-0.1,137.6-0.1,206.4,0c23.2,0,37.7,14.7,37.8,38c0.1,68.7,0.1,137.4,0,206c0,23.8-14.5,38.2-38.2,38.2 C218.4,502.9,184,502.9,149.6,502.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.9,9c69,0,138,0,207,0c25.6,0,39.3,13.8,39.3,39.6c0,21.4,0.1,42.7,0,64.1c-0.1,22.6-14.5,37.2-36.9,37.2 c-139.6,0.1-279.2,0.1-418.9,0c-22.8,0-37.2-14.6-37.2-37.6c-0.1-21.6,0-43.2,0-64.8C9.2,23.2,23.2,9,47.4,9 C116.9,9,186.4,9,255.9,9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.5,361.9c0-34.2,0-68.5,0-102.7c0-24.2,14.2-38.5,38.5-38.6c21.3-0.1,42.7-0.1,64,0c23.8,0.1,38.2,14.5,38.3,38.1 c0,68.7,0,137.4,0,206.1c0,23.9-14.2,38.1-38.1,38.1c-21.6,0-43.1,0.1-64.7,0c-23.7-0.1-37.9-14.4-37.9-38.3 C361.4,430.4,361.5,396.1,361.5,361.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidget);
export default __webpack_public_path__ + "static/media/widget.382f0e1607c421cd6ebeefc2d384f06a.svg";
export { ForwardRef as ReactComponent };